export default {
    it: {
    },
    en: {
    }
}